import { TemplatePageProps } from './types'
import { BingoBlissEntity } from './entity'
import Icon from 'images/games/bingo-bliss/icon.png'
import Swiper1 from 'images/games/bingo-bliss/swiper1.webp'
import Swiper2 from 'images/games/bingo-bliss/swiper2.webp'
import Swiper3 from 'images/games/bingo-bliss/swiper3.webp'
import Swiper4 from 'images/games/bingo-bliss/swiper4.webp'
import Swiper5 from 'images/games/bingo-bliss/swiper5.webp'
import Swiper6 from 'images/games/bingo-bliss/swiper6.webp'
import Swiper7 from 'images/games/bingo-bliss/swiper7.webp'
import Detail1 from 'images/games/bingo-bliss/detail1.png'
import Detail2 from 'images/games/bingo-bliss/detail2.png'
import Detail3 from 'images/games/bingo-bliss/detail3.png'
import Footer from 'images/games/bingo-bliss/footer.png'
import {
  BingoClashLink,
  BingoTourLink,
  BlockolotLink,
  BubbleBuzzLink,
  EightBallStrikeLink,
  GamesLink,
  SolitaireClashLink,
} from '../../components'

export const BingoBlissDetail: TemplatePageProps = {
  entity: {
    ...BingoBlissEntity,
    logo: Icon,
    title: (
      <>
        <strong>Bingo Bliss</strong>: The Ultimate <strong>Bingo Game</strong> Experience
      </>
    ),
    description: (
      <>
        Enter the world of Bingo Bliss, a <strong>bingo game</strong> where classic gameplay meets real rewards. Enjoy
        blissful rounds and joyful in-game events that keep the fun going. Download Bingo Bliss now on the App Store,
        Galaxy Store, or Android APK for the most delightful bingo experience!
      </>
    ),
  },
  swiper: [
    { image: Swiper1 },
    { image: Swiper2 },
    { image: Swiper3 },
    { image: Swiper4 },
    { image: Swiper5 },
    { image: Swiper6 },
    { image: Swiper7 },
  ],
  content: [
    {
      title: (
        <>
          Mastering <strong>Bingo Bliss</strong>: How to Play and Win
        </>
      ),
      description: (
        <>
          Bingo Bliss delivers fast, engaging rounds packed with power-ups and high-energy daubing. Race against the
          clock to daub numbers, complete your card, and rack up points. Boost your score with power-ups like Gimme More
          (G) to pick the next number, Daub It (Diamond) to instantly mark any spot, and x2 to double your points in
          select cash matches. Since opponents’ moves are hidden, it’s all about speed and strategy. Time your power-ups
          right, and you might even uncover bonus cash for an extra edge. Every round of Bingo Bliss delivers fun and
          satisfying daubing action that keeps you coming back for more!
        </>
      ),
      image: Detail1,
    },
    {
      title: <>Play for Bliss, Compete for Cash</>,
      description: (
        <>
          Play Bingo Bliss, where every match is designed to challenge your ability to think strategically. Matches pair
          players of similar skill levels, and everyone receives identical bingo boards, number calls, and time limits,
          for a truly fair game. Victory comes down to how quickly you mark off correct numbers, how wisely you use
          power-ups, and how effectively you execute your moves. But be careful, because daubing the wrong number
          triggers a penalty. This isn’t your ordinary bingo game. It’s a leveled-up experience that keeps you on your
          toes. With each match offering a level playing field, it&#39;s all about refining your skills and outsmarting
          your opponents to win real rewards.
        </>
      ),
      image: Detail2,
    },
    {
      title: <>Fast, Safe, Blissful Payments</>,
      description: (
        <>
          Bingo Bliss lets you compete for exciting prize pools in every match — join Ticket Matches for free bingo fun
          or Cash Matches to play for real cash rewards. When it&#39;s time to collect your winnings, cashing out is
          easy and secure with trusted platforms like PayPal. Deposits are just as simple, with multiple payment options
          available, including Venmo, Apple Pay, Visa, Mastercard, Amex, and Discover. Every transaction is processed
          with advanced encryption to keep your funds safe. And if you ever have questions, a dedicated customer support
          team is ready to help. With reliable payouts and smooth service, Bingo Bliss makes sure your focus stays on
          the fun.
        </>
      ),
      image: Detail3,
    },
    {
      title: <>Keep the Bliss Going: Play More Games!</>,
      description: (
        <>
          If you enjoy the exciting <strong>bingo games</strong> and rewards in Bingo Bliss, even more captivating
          adventures await with Avia’s wide range of <GamesLink>free games</GamesLink>. Keep the bingo fun going with{' '}
          <BingoClashLink /> and <BingoTourLink />, or explore other exciting categories like card games in{' '}
          <SolitaireClashLink />, pool battles in <EightBallStrikeLink />, bubble popping in
          <BubbleBuzzLink />, and strategic block stacking in <BlockolotLink />. Explore Avia’s full collection and
          discover even more games designed to keep you entertained and engaged!
        </>
      ),
    },
  ],
  footer: {
    image: Footer,
  },
}
